export default "__VITE_ASSET__DNZG0mEb__"